export default "0e300272f65ffd84.svg"